<div class="panel-header">
	<div class="column title">
		<h2>
			<span>Aanwezigheid per maand</span>
			<app-icon
				name="info"
				color="primary-1"
				hoverColor="primary-2"
				size="small"
				[appTooltip]="aanwezigheidInfo"
				data-princexml-ignore
				data-html2canvas-ignore
			></app-icon>
		</h2>
		@if (showDetailsButton()) {
			<div class="subtitle" data-princexml-ignore data-html2canvas-ignore>Schooljaar {{ schooljaar() }}</div>
			<div class="subtitle" data-export-only>{{ dataRootSelection()?.size }} leerlingen - schooljaar {{ schooljaar() }}</div>
		} @else {
			<div class="subtitle">Schooljaar {{ schooljaar() }}</div>
		}
	</div>
	<div class="toggle" data-princexml-ignore data-html2canvas-ignore>
		<app-toggle-button [checked]="toonAfgeslotenLessen()" (toggled)="toonAfgeslotenLessen.set($event)" [after]="true">
			Toon datavolledigheid (%)
		</app-toggle-button>
	</div>
	<ng-template #aanwezigheidInfo>
		<div class="tooltip">
			<h4>Aanwezigheid per maand</h4>
			<p>Toont de gemiddelde aanwezigheid van de geselecteerde leerlingen per maand binnen het gekozen schooljaar t/m de vorige maand.</p>
			<ul>
				<li>Goede aanwezigheid (groen) • ≥ 95%</li>
				<li>Beginnend verzuim (geel) • &gt; 90% &lt; 95%</li>
				<li>Aanhoudend verzuim (rood) • ≤ 90%</li>
			</ul>
		</div>
	</ng-template>

	@if (showDetailsButton() && dataRootSelection()) {
		<div class="column" data-princexml-ignore data-html2canvas-ignore>
			<app-button buttonType="secondary" icon="chevron-right" icon-right (clickit)="urlService.navigateToSelection(dataRootSelection())">
				Bekijk {{ dataRootSelection()?.size }} leerlingen
			</app-button>
		</div>
	}
</div>
<div class="panel-content">
	@if (!loading()) {
		@if (partitions().length > 0) {
			<app-vbar-series
				[partitions]="partitions()"
				[style]="Style.PLANE"
				[barHeight]="afgeslotenLessen() ? 310 : 392"
				[barWidth]="barWidth()"
				[paddingLeft]="paddingLeft"
				[paddingTop]="8"
				[paddingBottom]="25"
				[yAxis]="yAxis"
				textAlign="top"
				tooltipClass="first-line-bold"
			></app-vbar-series>
			@if (afgeslotenLessen(); as metricsData) {
				<app-metrics-series [metrics]="metricsData" [paddingLeft]="paddingLeft" [barWidth]="barWidth()"></app-metrics-series>
				<div class="datavolledigheid-info">Percentage lessen met ingevoerde presentie waarop de schoolaanwezigheid is gebaseerd.</div>
			}
		} @else {
			<div>De huidige selectie levert geen resultaten op.</div>
		}
	}
</div>
